import {
  useAccountingConnectionQuery,
  useFinalyticConnectionQuery,
} from '@vrplatform/data';
import { useStatementAutomation } from '../views/statements/legacy/_hooks';
import { useMemo } from 'react';

export function useListingClassMappingInfo() {
  const { finalyticConnectionId, loading: loadingFinalyticConnection } =
    useFinalyticConnectionQuery();
  const { accounting, loading } = useAccountingConnectionQuery();
  const { billAutomation: automation, isInitialLoading } =
    useStatementAutomation();
  const accountingConnectionId = accounting?.id;

  const rightType =
    accounting?.appId === 'xero'
      ? 'xero.trackingCategory'
      : `${accounting?.appId}.class`;
  const leftType = 'finalytic.listing';
  const key = 'class';

  return useMemo(
    () => ({
      loading: loading || isInitialLoading || loadingFinalyticConnection,
      mapping: {
        rightType,
        leftType,
        rightParams: automation?.mappings?.[key]?.right?.params || {},
        leftParams:
          automation?.mappings?.[key]?.left?.params ||
          automation?.mappings?.[key]?.params ||
          {},
        key,
      },
      automation: {
        automation,
        finalyticConnectionId,
        accountingConnectionId,
      },
      accounting,
    }),
    [
      loading,
      isInitialLoading,
      accounting,
      automation,
      finalyticConnectionId,
      loadingFinalyticConnection,
      rightType,
      accountingConnectionId,
    ]
  );
}
